/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccountDataCheckSample} from '../api'

 export const useQueryGetAccountDataCheckSample = createReactQueryHook('getAccountDataCheckSample', getAccountDataCheckSample)
